export default __webpack_public_path__ + "static/media/calendarIcon.a26c505f.svg";